import axios from 'axios';
import http from '../utils/http';

/**
 * 订单管理-交易订单 
 **/
// 交易订单-获取交易订单列表
export const OrderList = (params) => { 
    return http.get("/api/v1/front/order/list", params) 
};
// 获取订单详情
export const orderDetail = (id) => { return http.get( `/api/v1/front/order/${id}`) };

/**
 * 我的产品 
 **/
// 交易订单-获取产品列表
export const OrderProductList = (params) => { 
    return http.get("/api/v1/front/order/product/list", params) 
};


// WEBPACK FOOTER //
// ./src/api/orderMG.js